import api from '@/assets/js/api';

export default class uploadAdaptor {
    constructor(loader, url) {
        this.loader = loader;
        this.url = url;
    }

    upload() {
        return this.loader.file.then(
            (file) =>
                new Promise((resolve, reject) => {
                    this._sendRequest(resolve, file);
                })
        );
    }

    _sendRequest(resolve, file) {
        const reader = new FileReader();
        const thisFile = file;
        reader.readAsDataURL(file);
        const result = {};
        reader.onload = async (file) => {
            const fileObj = {
                filename: thisFile.name,
                mimetype: thisFile.type,
                base64data: file.target.result.split(',')[1],
            };
            const { data } = await this._postUploadFile(fileObj);
            console.log('===> Success Upload Image : ', { url: data.fileUrl });
            resolve({ default: data.fileUrl });
        };
    }

    _postUploadFile(fileObj) {
        return api.post(this.url, {
            ...fileObj,
        });
    }
}
